import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { FormService } from "src/app/services/form.service";
import { GenreService } from "src/app/services/genre.service";
import { catchError, map, throwError } from "rxjs";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
})
export class FooterComponent {
  env = environment.assUrl;

  openSections: { [key: string]: boolean } = {
    products: true,  // First dropdown open by default
    solutions: false,
    company: false,
    resources: false,
    usefulLinks: false,
  };

  toggleSection(section: string) {
    // If the clicked section is already open, close it
    if (this.openSections[section]) {
      this.openSections[section] = false;
    } else {
      // Close all sections first
      Object.keys(this.openSections).forEach(key => {
        this.openSections[key] = false;
      });
      // Then open the clicked section
      this.openSections[section] = true;
    }
  }


  subscriptionForm: FormGroup;

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private form: FormService,
    private genre: GenreService
  ) {
    this.subscriptionForm = this.formBuilder.group({
      name: ["", Validators.required],
      email: ["", [Validators.required, Validators.email]],
      myCheckbox: [false],
    });
  }

  goto(path: String) {
    this.router.navigate([path]);
  }

  subscribe() {
    if (this.subscriptionForm.valid) {
      this.subscribeCall();
    } else {
      // Mark all fields as touched to display validation errors
      this.subscriptionForm.markAllAsTouched();
    }
  }

  subscribeCall() {
    const body = {
      name: this.subscriptionForm.value.name,
      email: this.subscriptionForm.value.email,
    };

    this.form.subscribe(body).subscribe(
      (res: any) => {
        if (res.error === false) {
        } else {
        }
      },
      (error) => {
        console.error("Error:", error);
      }
    );
  }

  products = [
    { name: "Interactive Flat Panel", link: "/interactive-flat-panel-smart-classroom" },
    { name: "IFP Protection (Shutter)", link: "/shutter-system" },
    { name: "All-in-One PCs", link: "/all-in-one-pc-computers-accessories" },
    { name: "LMS", link: "/lms" },
    { name: "K-12 Digital Content", link: "/k-12-digital-content" },
    { name: "Digital E-Library", link: "/digital-e-library" },
  ];

  solutions = [
    { name: "Schools", link: "/solutions/schools" },
    { name: "Education Institutions", link: "/solutions/education-institutions" },
    { name: "Corporates", link: "/solutions/corporates" },
    { name: "Government", link: "/solutions/government" },
    { name: "Partners", link: "/solutions/partners" },
  ];

  company = [
    { name: "About Us", link: "/about-us" },
    // { name: "Leadership", link: "/leadership" },
    // { name: "Careers", link: "/careers" },
    { name: "Vision & Mission", link: "/about-us", fragment: "vision-mission" },

  ];

  resources = [
    { name: "Blog", link: "/blog" },
    { name: "Case Studies", link: "/case-studies" },
    { name: "Brochures", link: "/brochures" },
    { name: "Videos", link: "/videos" },
  ];

  usefulLinks = [
    { name: "Partnership", route: "/form/partnership" },
    { name: "Privacy Policy", route: "/privacy" },
    { name: "Terms & Conditions", route: "/term-condition" },
    { name: "Refund Policy", route: "/refund-policy" },
    // { name: "Careers", route: "/careers" },
    { name: "Our Social Initiative", route: "/social-initiative" },
    { name: "Get in Touch", route: "/form/contactUs" },
  ];

  contactInfo = {
    phone: "+91-9667166988",
    email: "info@virsaindia.in",
    whatsapp: "https://wa.me/919667166988",
    address: "G2, Max Towers, Delhi One, Sector-16 B, Gautam Buddh Nagar, Noida, Uttar Pradesh-201301"
  };

  socialLinks = [
    {
      icon: "assets/images/icons/ic_facebook.png",
      alt: "Facebook",
      url: "https://www.facebook.com/virsaindia12",
    },
    {
      icon: "assets/images/icons/twitter-icon.png",
      alt: "Twitter",
      url: "https://x.com/virsa2103",
    },
    {
      icon: "assets/images/icons/ic_linkedin.png",
      alt: "LinkedIn",
      url: "https://www.linkedin.com/company/virsaindia",
    },
    {
      icon: "assets/images/icons/ic_youtube.png",
      alt: "YouTube",
      url: "https://www.youtube.com/@VirsaIndia",
    },
    {
      icon: "assets/images/icons/ic_insta.png",
      alt: "Instagram",
      url: "https://www.instagram.com/virsa1000/",
    },
  ];
}
